import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'


export default class extends React.Component {
    static propTypes = {
		slug: PropTypes.string,
		interests: PropTypes.array.isRequired,
	};

    interest = (interest) => {

		let { ID, link, slug, title } = interest,
			colourClass = slug === this.props.slug ? 'text-mid-success' : 'text-dark-gray';

		return <Link to={`/discover/${slug}`} className={colourClass + ' interest-filter-link'} key={'filter-'+ID}>{title}</Link>

	};

    render() {

		return <span>{ this.props.interests.map(this.interest) }</span>
		
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Discover/components/Filters/components/Interests.jsx